import { _ as _export } from '../internals/export.js';
import { g as global$1 } from '../internals/global.js';
import { s as schedulersFix$1 } from '../internals/schedulers-fix.js';

var $ = _export;
var global = global$1;
var schedulersFix = schedulersFix$1;

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});
